import RcSlider, { Range as RcRange, createSliderWithTooltip } from 'rc-slider';
import { styled, css } from 'styled-components';
export const SliderActionButton = styled.div `
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  min-width: 18px;
  min-height: 18px;
  max-width: 18px;
  max-height: 18px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.grey00_6};
  user-select: none;
  color: ${({ theme }) => theme.colors.black_1};
  ${({ theme }) => theme.shadows.large}
`;
const commonSliderStyles = css `
  position: relative;
  padding: 5px 0;
  width: 100%;
  border-radius: 6px;
  touch-action: none;
  box-sizing: border-box;

  & .rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.grey05_2};
    height: 1px;
    border-radius: 6px;
  }

  & .rc-slider-track {
    position: absolute;
    left: 0;
    height: 1px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.main};
  }

  & .rc-slider-handle {
    position: absolute;
    width: 9px;
    height: 9px;
    margin-top: -4px;
    cursor: grab;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.main};
    touch-action: pan-x;
  }

  & .rc-slider-handle:active {
    border-color: ${({ theme }) => theme.colors.mainLight};
    box-shadow: 0 0 5px ${({ theme }) => theme.colors.mainLight};
    cursor: grabbing;
  }

  & .rc-slider-handle:focus {
    border-color: ${({ theme }) => theme.colors.mainLight};
    box-shadow: 0 0 0 5px ${({ theme }) => theme.colors.mainLight};
    outline: none;
  }

  & .rc-slider-handle-click-focused:focus {
    border-color: ${({ theme }) => theme.colors.mainLight};
    box-shadow: unset;
  }
`;
const sliderStyles = css `
  ${commonSliderStyles};
  height: 14px;
`;
export const Slider = styled(RcSlider) `
  ${sliderStyles};
`;
export const SliderWithTooltip = styled(createSliderWithTooltip(RcSlider)) `
  ${sliderStyles};
`;
export const Range = styled(RcRange) `
  ${commonSliderStyles}

  & .rc-slider-step {
    position: relative;
  }

  & .rc-slider-mark {
    height: ${({ $marked }) => ($marked ? '20px' : 'auto')};
    margin-top: 8px;
  }

  & .rc-slider-mark-text {
    position: absolute;
  }

  & .rc-slider-dot {
    position: absolute;
    width: 5px;
    height: 5px;
    border: 1px solid ${({ theme }) => theme.colors.grey05_1};
    top: -2px;
    background-color: ${({ theme }) => theme.colors.grey00_1};
    border-radius: 50%;
    transform: translateX(-50%);

    &.rc-slider-dot-active {
      background-color: ${({ theme }) => theme.colors.main};
      border-color: ${({ theme }) => theme.colors.main};
    }
  }
`;
